// Globales CSS gehoert in den Custom App - das ist die einzige von Next.js
// dafuer vorgesehene Stelle im Pages Router. Frueher wurde es aus
// SiteLayout.jsx importiert; das kompilierte zwar, war aber nicht der
// unterstuetzte Weg.
import '@/styles/globals.css';

function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}

export default MyApp;
